/**
 * reexport
 *
 * @author Dominique Rau [domi.github@gmail.com](mailto:domi.github@gmail.com)<br/>
 * @version 0.0.1
 */

const webIcons = require('./web');
exports.Icons = webIcons.default;